__turbopack_context__.v({
  "container": "kiVkHG_container",
  "message": "kiVkHG_message",
  "uvpPlus": "kiVkHG_uvpPlus",
});
